export const FORGOT_PASSWORD_SUCCESS_CARD_TITLE = 'Check your email';
export const FORGOT_PASSWORD_SUCCESS_CARD_SUBTITLE =
  'We emailed you a link that allows you to reset your password.';
